import Input from '../../components/Input'
import { formatNumber, onChange } from '../../utils/functions'
import { COLOR_PATH, addColor, getPageColors } from '../../api/colorApi'
import { useDispatch } from 'react-redux'
import Button from '../../components/Button'
import Textarea from '../../components/Textarea'
import { useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { toast } from 'react-toastify'
import { PRODUCT_TYPES, VALIDATION_MESSAGE } from '../../utils/constants'
import { useApiProgress } from '../../hooks/ApiProgress'
import { Fragment, useEffect, useState } from 'react'
import { Transition, Dialog, Combobox } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import Spinner from '../../components/Spinner'
import { RxCross1 } from "react-icons/rx";
import useFirstRender from '../../hooks/FirstRender'
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi'
import { AiFillEdit, AiFillDelete } from 'react-icons/ai'
import { CUSTOMER_PATH, getCustomerById, getPageCustomers } from '../../api/customerApi'
import { getOrderById, updateOrder } from '../../api/orderApi'
import { addOrderDetail, deleteOrderDetail, getAllOrderDetails, updateOrderDetail } from '../../api/orderDetailsApi'
import ProductPicker from '../../components/product/ProductPicker'
import CustomerPicker from '../../components/customer/CustomerPicker'
import ProductLabel from '../../components/product/ProductLabel'
import { FaPlus } from 'react-icons/fa'

const OrderEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams()
    const isFirstRender = useFirstRender()
    const closeTab = useCloseTab()

    const [customerPage, setCustomerPage] = useState({
        content: []
    });

    const [productPage, setProductPage] = useState({
        content: []
    });

    const [customerQuery, setCustomerQuery] = useState('')
    const [productQuery, setProductQuery] = useState('')
    const [searchTimerCustomer, setSearchTimerCustomer] = useState();
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const pendingApiCallCustomer = useApiProgress('get', `${CUSTOMER_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)

    const [customer, setCustomer] = useState()
    const [errors, setErrors] = useState({})
    const [order, setOrder] = useState({
        orderDate: "",
        vat: "",
        invoiceNumber: "",
        description: ""
    })
    const [orderDetails, setOrderDetails] = useState([])
    const [detail, setDetail] = useState({
        product: null,
        quantity: "",
        unitPrice: ""
    })

    const [detailUpdate, setDetailUpdate] = useState({
        product: null,
        quantity: "",
        unitPrice: ""
    })

    const [isOpenUpdateDetailModal, setIsOpenUpdateDetailModal] = useState(false)

    const searchingCustomer = async (params) => {
        if (searchTimerCustomer) clearTimeout(searchTimerCustomer);
        let timer = setTimeout(() => {
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(res.data)
                })
        }, 500);
        setSearchTimerCustomer(timer);
    }

    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const onClickLoadMoreCustomer = () => {
        if (!customerPage.last) {
            loadCustomers({ search: customerQuery, lastId: customerPage.content[customerPage.content.length - 1]?.id })
        }
    }

    const loadCustomers = (params) => {
        !pendingApiCallCustomer &&
            getPageCustomers(params)
                .then(res => {
                    setCustomerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    useEffect(() => {
        !isFirstRender && searchingCustomer({ search: customerQuery })
    }, [customerQuery])

    useEffect(() => {
        loadCustomers({ size: 20 })
        loadProducts({ size: 20 })
    }, [])

    useEffect(() => {
        getOrderById(id)
            .then(res => {
                setOrder(res.data)
                getCustomerById(res.data.customerId)
                    .then(res => {
                        setCustomer(res.data)
                    })
            })
        getAllOrderDetails({ orderId: id })
            .then(res => {
                setOrderDetails(res.data)
            })
    }, [id])

    const onClickAddDetail = () => {
        const { product, quantity, unitPrice } = detail
        if (!product || !quantity || !unitPrice) {
            toast.error(VALIDATION_MESSAGE)
            return
        }
        const body = {
            productId: detail.product?.id,
            quantity: detail.quantity,
            unitPrice: detail.unitPrice,
            orderId: id
        }
        addOrderDetail(body)
            .then(res => {
                setOrderDetails(prevState => ([...prevState, res.data]))
                toast.success('Sipariş detayı kaydedildi')
            })
    }

    const onClickDeleteDetail = (id) => {
        deleteOrderDetail(id)
            .then(res => {
                setOrderDetails(prevState => (prevState.filter(p => p.id !== id)))
                toast.success('Sİpariş kaydı silindi')
            })
    }

    const onClickUpdateDetail = () => {
        const body = {
            productId: detailUpdate.product?.id,
            quantity: detailUpdate.quantity,
            unitPrice: detailUpdate.unitPrice
        }
        updateOrderDetail(detailUpdate.id, body)
            .then(res => {
                setOrderDetails(prevState => prevState.map((p) => {
                    if (p.id === res.data.id) return res.data
                    else return p
                }))
                toast.success('Sipariş kaydı güncellendi')
                setDetailUpdate({
                    product: null,
                    quantity: "",
                    unitPrice: ""
                })
                setIsOpenUpdateDetailModal(false)
            })
    }

    const onSubmit = () => {
        const orderBody = {
            customerId: customer?.id,
            orderDate: order.orderDate,
            vat: order.vat,
            invoiceNumber: order.invoiceNumber,
            description: order.description,
            parity: order.parity
        }
        updateOrder(id, orderBody)
            .then(res => {
                toast.success('Sipariş kaydedildi')
                closeTab()
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Sipariş Düzenle</label>
            </div>
            <div className='grid grid-cols-12 gap-x-3 mb-10'>
                <CustomerPicker
                    label='Müşteri'
                    pendingApiCall={pendingApiCallCustomer}
                    state={customer}
                    setState={(value) => setCustomer(value)}
                    query={customerQuery}
                    setQuery={setCustomerQuery}
                    error={errors.customerId}
                    page={customerPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, customerId: undefined }))}
                    onClickClear={() => setCustomer()}
                    onClickLoadMore={() => onClickLoadMoreCustomer()}
                    disabled={order.charged}
                />
                <div className='col-span-2'>
                    <Input
                        name='orderDate'
                        label='Sipariş Tarihi'
                        type='date'
                        value={order.orderDate}
                        error={errors?.orderDate}
                        onChange={e => onChange(e, setOrder, setErrors)}
                        disabled={order.charged}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='vat'
                        label='Vergi Oranı (%)'
                        type='number'
                        placeholder='Vergi oranı...'
                        value={order.vat}
                        error={errors?.vat}
                        onChange={e => onChange(e, setOrder, setErrors)}
                        disabled={order.charged}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumber'
                        label='Fatura Numarası'
                        type='text'
                        placeholder='Fatura numarası...'
                        value={order.invoiceNumber}
                        error={errors?.invoiceNumber}
                        onChange={e => onChange(e, setOrder, setErrors)}
                        disabled={order.charged}
                    />
                </div>
                <div className='col-span-1'>
                    <Input
                        name='parity'
                        label='Parite'
                        type='number'
                        placeholder='Parite...'
                        value={order.parity}
                        error={errors?.parity}
                        onChange={e => onChange(e, setOrder, setErrors)}
                    />
                </div>
                <div className='col-span-2'>
                    <Textarea
                        name='description'
                        label='Açıklama'
                        type='text'
                        placeholder='Açıklama girin...'
                        value={order.description}
                        error={errors?.description}
                        onChange={e => onChange(e, setOrder, setErrors)}
                        disabled={order.charged}
                    />
                </div>
            </div>
            <table className='w-full text-left text-zinc-900 mb-10'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>#</th>
                        <th className='p-2 w-4/12'>Ürün</th>
                        <th className='p-2 w-2/12'>Metre</th>
                        <th className='p-2 w-2/12'>{`Birim Fiyat ${customer ? `(${customer.currency}/m)` : ""}`} </th>
                        <th className='p-2 w-2/12'>Toplam {customer ? `(${customer.currency})` : ""}</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        orderDetails.map((detail, index) => (
                            <tr className='border-b items-center sticky top-20 bg-zinc-50' key={index}>
                                <td>{index + 1} </td>
                                <td>{detail.product && <ProductLabel state={detail.product} />} </td>
                                <td>{formatNumber(detail.quantity)} m</td>
                                <td>{formatNumber(detail.unitPrice)}</td>
                                <td>{formatNumber((detail.unitPrice * detail.quantity).toFixed(2))} </td>
                                <td className='p-2 flex gap-x-3'>
                                    {
                                        !order.charged &&
                                        <>
                                            <span
                                                className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150'
                                                onClick={() => {
                                                    setDetailUpdate(detail)
                                                    setIsOpenUpdateDetailModal(true)
                                                }}>
                                                <AiFillEdit />
                                            </span>
                                            <span
                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                onClick={() => {
                                                    onClickDeleteDetail(detail.id)
                                                }}
                                            >
                                                <AiFillDelete />
                                            </span>
                                        </>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                    <tr className='bg-zinc-200'>
                        <td className='py-2'>Toplam</td>
                        <td></td>
                        <td className='py-2'>{formatNumber(orderDetails.reduce((a, c) => a + Number(c.quantity), 0))} m</td>
                        <td></td>
                        <td className='py-2'>{formatNumber((orderDetails.reduce((a, c) => a + c.unitPrice * c.quantity, 0)).toFixed(2))} {customer ? `${customer.currency}` : ""}</td>
                        <td></td>
                    </tr>
                    {
                        !order.charged &&
                        <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                            <td></td>
                            <td>
                                <ProductPicker
                                    //label='Ürün'
                                    pendingApiCall={pendingApiCallProduct}
                                    state={detail.product}
                                    setState={(value) => setDetail(prevState => ({ ...prevState, product: value }))}
                                    query={productQuery}
                                    setQuery={setProductQuery}
                                    error={errors.productId}
                                    page={productPage}
                                    setErrors={prevState => ({ ...prevState, productId: undefined })}
                                    //onClickClear={() => setDetail(prevState => ({ ...prevState, product: undefined }))}
                                    onClickLoadMore={() => onClickLoadMoreProduct()}
                                />
                            </td>
                            <td>
                                <Input
                                    type='number'
                                    placeholder='Metre girin...'
                                    value={detail.quantity}
                                    name='quantity'
                                    onChange={e => onChange(e, setDetail)}
                                />
                            </td>
                            <td>
                                <Input
                                    type='number'
                                    placeholder='Birim fiyat girin...'
                                    value={detail.unitPrice}
                                    name='unitPrice'
                                    onChange={e => onChange(e, setDetail)}
                                />
                            </td>
                            <td></td>
                            <td>
                                <span onClick={onClickAddDetail}><FaPlus /></span>
                            </td>
                        </tr>
                    }


                </tbody>
            </table>
            {
                !order.charged &&
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onSubmit}
                    />
                </div>
            }

            <Transition appear show={isOpenUpdateDetailModal} as={Fragment}>
                <Dialog as="div" onClose={() => setIsOpenUpdateDetailModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                    >
                                        Sipariş Planı Güncelle
                                    </Dialog.Title>

                                    {/* INPUT_DETAIL PRODUCT PICKER */}
                                    <div>

                                        <div className="w-full mb-3">
                                            <div className='flex items-center justify-between'>
                                                <span className='flex items-center'>

                                                    {pendingApiCallProduct && <Spinner />}
                                                </span>
                                                {
                                                    detailUpdate.product &&
                                                    <span onClick={() => setDetailUpdate(prevState => ({ ...prevState, product: null }))}>
                                                        <RxCross1 />
                                                    </span>
                                                }
                                            </div>
                                            <Combobox
                                                value={detailUpdate.product ? `${detailUpdate.product.collectionCode}${detailUpdate.product.color ? `, ${detailUpdate.product.color.code}` : ""}${detailUpdate.product.weight ? `, ${detailUpdate.product.weight.code}` : ""}${detailUpdate.product.pattern ? `, ${detailUpdate.product.pattern.code}` : ""}` : ""}
                                                onChange={(product) => { setDetailUpdate(prevState => ({ ...prevState, product })) }}
                                            >
                                                <div className="relative mt-1">
                                                    <div className="relative w-full cursor-default overflow-hidden rounded-md bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
                                                        <Combobox.Input
                                                            placeholder='Arama yapın...'
                                                            className="w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 outline-none"
                                                            displayValue={detailUpdate.product?.name}
                                                            onChange={(event) => setProductQuery(event.target.value)}
                                                        />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                                                            <ChevronUpDownIcon
                                                                className="h-5 w-5 text-gray-400"
                                                                aria-hidden="true"
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Transition
                                                        as={Fragment}
                                                        leave="transition ease-in duration-100"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                        afterLeave={() => setProductQuery('')}
                                                    >
                                                        <Combobox.Options className="z-50 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                                            {productPage.content.length === 0 && productQuery !== '' ? (
                                                                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                                                                    Kayıt bulunamadı.
                                                                </div>
                                                            ) : (
                                                                productPage.content.map((product) => (
                                                                    <Combobox.Option
                                                                        key={product.id}
                                                                        className={({ active }) =>
                                                                            `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                            }`
                                                                        }
                                                                        value={product}
                                                                    >
                                                                        {({ selected, active }) => (
                                                                            <>
                                                                                <span
                                                                                    className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                                        }`}
                                                                                >
                                                                                    <div className='border p-2 text-xs'>
                                                                                        <label className='block'> Ürün Kodu : {product.collectionCode}</label>
                                                                                        <label className='block'> Ürün Adı : {product.collectionName}</label>
                                                                                        {product.color && <label className='block'> Renk Kodu : {product.color.code}</label>}
                                                                                        {product.weight && <label className='block'> Gramaj Kodu : {product.weight.code}</label>}
                                                                                        {product.pattern && <label className='block'> Desen Kodu : {product.pattern.code}</label>}
                                                                                    </div>
                                                                                </span>
                                                                                {selected ? (
                                                                                    <span
                                                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                                                                            }`}
                                                                                    >
                                                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                                                    </span>
                                                                                ) : null}
                                                                            </>
                                                                        )}
                                                                    </Combobox.Option>
                                                                ))
                                                            )}
                                                            {
                                                                !productPage.last &&
                                                                <Combobox.Option
                                                                    onClick={e => {
                                                                        onClickLoadMoreProduct()
                                                                        e.preventDefault()
                                                                    }}

                                                                    className={({ active }) =>
                                                                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-teal-600 text-white' : 'text-gray-900'
                                                                        }`
                                                                    }

                                                                >
                                                                    Daha fazla yükle
                                                                </Combobox.Option>
                                                            }
                                                        </Combobox.Options>
                                                    </Transition>
                                                </div>
                                            </Combobox>



                                        </div>
                                        <div className='col-span-3'>
                                            <Input
                                                type="number"
                                                label='Miktar (m)'
                                                name="quantity"
                                                placeholder='Metre'
                                                value={detailUpdate.quantity}
                                                onChange={e => onChange(e, setDetailUpdate)}
                                            />
                                        </div>
                                        <div className='col-span-3'>
                                            <Input
                                                type="number"
                                                label='Birim Fiyat'
                                                name="unitPrice"
                                                placeholder='Birim fiyat...'
                                                value={detailUpdate.unitPrice}
                                                onChange={e => onChange(e, setDetailUpdate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenUpdateDetailModal(false)}
                                        >
                                            İptal

                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 disabled:bg-blue-100"
                                            onClick={onClickUpdateDetail}
                                        //disabled={!variation.color && !variation.pattern && !variation.weight}
                                        >
                                            Kaydet
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

        </div>
    )
}

export default OrderEditPage